import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
export const userProfilePath = 'connect-community/v1/user-profiles';
export const GET_USER_BY_ID = registerQuery({
  fieldName: 'userById',
  args: ['userId'],
  fetcher({
    userId
  }) {
    return noAuthApiClient.get(`${userProfilePath}/user-id/${userId}`);
  }
});
export const useConnectDotComUserById = userId => {
  const {
    data: connectDotComUser,
    error: connectDotComUserError,
    loading: connectDotComUserLoading
  } = useQuery(GET_USER_BY_ID, {
    variables: {
      userId: userId
    },
    skip: !userId
  });
  return {
    connectDotComUser,
    connectDotComUserError,
    connectDotComUserLoading
  };
};
export const useConnectDotComUser = userId => {
  return useConnectDotComUserById(userId);
};